<template>
    <div>
        
        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>       
        <Loader v-if="loading" />
        <div v-else-if="data.department.id">
            <!-- <h3>{{data.department.name}}</h3> -->

            <PageTitle v-bind:title="title" v-bind:admin="false" />

            <img v-if="data.department.image" :src="data.department.image" alt="" height="300" class="shadow">

            <h3 class="mt-4">Описание</h3>
            <p>{{data.department.description}}</p>
           
            
            <template v-if="data.courses.length > 0">
                <h3 class="mt-4">Список курсов кафедры:</h3>
                <table class="table">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Наименование</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in data.courses" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>
                                <router-link :to="{ name: 'course_show', params: { id: item.id } }">{{ item.name }}</router-link>
                                <span v-if="item.status_id == 5" class="badge badge-success">отвечен</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <template v-else>
                <div class="alert alert-warning" role="alert">
                    У этой кафедры ещё нет Курсов!
                </div>
            </template>



        </div>



    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import PageTitle from '@/components/PageTitle'
//import jQuery from 'jquery'
export default {
    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '' },
            title: '',
        }
    },
   async mounted() {
       this.loadData()
    },
    methods: {
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('departments/'+this.$route.params.id)
                this.data = response.data
                this.title = this.data.department.name
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },
    },



    components: {
        Loader,
        PageTitle,
    }
}
</script>